/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Instant_FulfillmentInputs */

const en_pricing_feature_instant_fulfillment = /** @type {(inputs: Pricing_Feature_Instant_FulfillmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instant Digital Fulfillment`)
};

const es_pricing_feature_instant_fulfillment = /** @type {(inputs: Pricing_Feature_Instant_FulfillmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega Digital Instantánea`)
};

const fr_pricing_feature_instant_fulfillment = /** @type {(inputs: Pricing_Feature_Instant_FulfillmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livraison numérique instantanée`)
};

const de_pricing_feature_instant_fulfillment = /** @type {(inputs: Pricing_Feature_Instant_FulfillmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sofortige Digitale Erfüllung`)
};

const id_pricing_feature_instant_fulfillment = /** @type {(inputs: Pricing_Feature_Instant_FulfillmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemenuhan Digital Instan`)
};

/** @type {(inputs: Pricing_Feature_Instant_FulfillmentInputs) => LocalizedString} */
const ja_pricing_feature_instant_fulfillment = en_pricing_feature_instant_fulfillment;

/** @type {(inputs: Pricing_Feature_Instant_FulfillmentInputs) => LocalizedString} */
const zh_pricing_feature_instant_fulfillment = en_pricing_feature_instant_fulfillment;

/** @type {(inputs: Pricing_Feature_Instant_FulfillmentInputs) => LocalizedString} */
const ar_pricing_feature_instant_fulfillment = en_pricing_feature_instant_fulfillment;

/** @type {(inputs: Pricing_Feature_Instant_FulfillmentInputs) => LocalizedString} */
const it_pricing_feature_instant_fulfillment = en_pricing_feature_instant_fulfillment;

/** @type {(inputs: Pricing_Feature_Instant_FulfillmentInputs) => LocalizedString} */
const ru_pricing_feature_instant_fulfillment = en_pricing_feature_instant_fulfillment;

/** @type {(inputs: Pricing_Feature_Instant_FulfillmentInputs) => LocalizedString} */
const pt_pricing_feature_instant_fulfillment = en_pricing_feature_instant_fulfillment;

/** @type {(inputs: Pricing_Feature_Instant_FulfillmentInputs) => LocalizedString} */
const ko_pricing_feature_instant_fulfillment = en_pricing_feature_instant_fulfillment;

/**
* | output |
* | --- |
* | "Instant Digital Fulfillment" |
*
* @param {Pricing_Feature_Instant_FulfillmentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_instant_fulfillment = /** @type {((inputs?: Pricing_Feature_Instant_FulfillmentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Instant_FulfillmentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_instant_fulfillment(inputs)
	if (locale === "es") return es_pricing_feature_instant_fulfillment(inputs)
	if (locale === "fr") return fr_pricing_feature_instant_fulfillment(inputs)
	if (locale === "de") return de_pricing_feature_instant_fulfillment(inputs)
	if (locale === "ja") return ja_pricing_feature_instant_fulfillment(inputs)
	if (locale === "zh") return zh_pricing_feature_instant_fulfillment(inputs)
	if (locale === "ar") return ar_pricing_feature_instant_fulfillment(inputs)
	if (locale === "id") return id_pricing_feature_instant_fulfillment(inputs)
	if (locale === "it") return it_pricing_feature_instant_fulfillment(inputs)
	if (locale === "ru") return ru_pricing_feature_instant_fulfillment(inputs)
	if (locale === "pt") return pt_pricing_feature_instant_fulfillment(inputs)
	return ko_pricing_feature_instant_fulfillment(inputs)
});